import { z } from 'zod';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import { TFunction } from 'react-i18next';

export const micrositeFormSchema = (t: TFunction) =>
  z.object({
    font: z.string({
      invalid_type_error: t('microsite.font.missing'),
      required_error: t('microsite.font.missing'),
    }),
    sectionHeadingColor: z.string({
      invalid_type_error: t('microsite.sectionHeadingColor.missing'),
      required_error: t('microsite.sectionHeadingColor.missing'),
    }),
    tenantPortalUrl: z.string().optional(),
  });

export const micrositeFormValidationSchema = (t: TFunction) =>
  toFormikValidationSchema(micrositeFormSchema(t));
